<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-calendar-clock-outline"></i>
                <h2>Vencimento AGO</h2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sm-12">
              <hr />
            </div>
            <div class="sm-12 md-4">
              <p class="text-primary-darker-1">
                <strong>Condomínio:</strong>
                {{ condominio.nome }}
              </p>
            </div>
            <div class="sm-12 md-4">
              <!--
                <p class="text-primary-darker-1">
                    <strong>CNPJ:</strong>
                    {{ cliente.cpf | cpf_formatter }}
                </p>
                    -->
            </div>
            <div class="sm-12 md-4">
              <p class="text-primary-darker-1">
                <strong>Abreviação:</strong>
                {{ condominio.abrev }}
              </p>
            </div>
            <div class="sm-12">
              <p class="text-primary-darker-1">
                <strong>Endereço:</strong>
                {{ condominio.endereco.enderecoCompleto }}
              </p>
              <hr />
            </div>
            <div class="sm-12">
              <p class="text-primary-darker-1">
                <strong>Data de Vencimento da AGO</strong>
              </p>
              <p class="text-primary-darker-1">
                {{ condominio.vencimentoAGO }} ({{ dia_semana }})
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import formatCPF from "../../plugins/format-cpf";
import { DateTime } from "luxon";
export default {
  filters: {
    cpf_formatter(value) {
      return formatCPF(value);
    },
  },
  computed: {
    condominio() {
      return this.$store.getters.condominio;
    },
    cliente() {
      return this.$store.state.cliente;
    },
    vencimento_ago() {
      return this.condominio.vencimentoAGO.split("/").reverse().join("-");
    },
    dia_semana() {
      let vencimento = DateTime.fromSQL(this.vencimento_ago);
      //let vencimento = DateTime.fromSQL('2021-10-03');
      let dias = [
        "",
        "Domingo",
        "Segunda-Feira",
        "Terça-Feira",
        "Quarta-Feira",
        "Quinta-Feira",
        "Sexta-Feira",
        "Sábado",
      ];
      let dia = vencimento.weekdayLong;
      return dia;
      return dias[dia];
    },
  },
};
</script>
